module.exports = __webpack_public_path__ + "static/media/PM134.c356cd18.png";